import { promisifyDialog } from '@shared/utils/dialog'
import Bindphone from './bindphone.vue'

const bindphone = () => {
  return promisifyDialog(Bindphone)
}

export default bindphone